module.exports = __webpack_public_path__ + "img/Sadia.ed9f6013.jpeg";